import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recive-payment-notification',
  templateUrl: './recive-payment-notification.component.html',
  styleUrls: ['./recive-payment-notification.component.css']
})
export class RecivePaymentNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
